import { useState, useRef } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ja } from "date-fns/locale/ja";

// 日本語ロケールをグローバルに登録する（一度だけ実行すれば有効）
registerLocale("ja", ja);

/**
 * DatePickerField - トグル開閉対応の DatePicker ラッパー
 *
 * カレンダーボタンのクリックで開き・再クリックで閉じるトグル動作を
 * このコンポーネント内で完結させる。
 * isOpen state・closedByButtonRef・mousedown ハンドラの重複を解消する。
 *
 * @param {Date}       selected    - 選択中の日付（Date オブジェクト）
 * @param {function}   onChange    - 日付選択時のコールバック（Date オブジェクトを受け取る）
 * @param {ReactElement} customInput - ボタンとして使用するカスタム入力要素（CalendarButton を想定）
 * @param {...*}       pickerProps - react-datepicker に渡す追加プロパティ
 */
function DatePickerField({ selected, onChange, customInput, ...pickerProps }) {
  const [isOpen, setIsOpen] = useState(false);
  const closedByButtonRef = useRef(false);

  const handleMouseDown = (e) => {
    // カレンダーポップアップ内のクリック（矢印ナビ等）は無視する
    if (isOpen && !e.target.closest(".react-datepicker")) {
      closedByButtonRef.current = true;
      setIsOpen(false);
    }
  };

  const handleChange = (d) => {
    onChange(d);
    setIsOpen(false);
  };

  return (
    <div onMouseDown={handleMouseDown}>
      <DatePicker
        selected={selected}
        onChange={handleChange}
        open={isOpen}
        onInputClick={() => {
          if (closedByButtonRef.current) { closedByButtonRef.current = false; return; }
          setIsOpen(true);
        }}
        onClickOutside={() => setIsOpen(false)}
        customInput={customInput}
        {...pickerProps}
      />
    </div>
  );
}

export default DatePickerField;
